import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import Modal, { useModal } from 'modals/dialog'
import { UnorderedList, ListItem } from 'components/typography/list'
import Actions from 'components/form/actions'
import { Plain } from 'components/button'

const StatusFailed = ({ failed }) => {
    const { formatMessage } = useIntl()
    const { dismiss } = useModal()

    return (
        <>
            <Modal.Header heading={formatMessage({
                id: 'documents_bulk_status_failed_details_heading',
                defaultMessage: '{failed, plural, =0 {} =1 {Failed to process the document} other {Failed to process {failed} documents}}'
            }, { failed: failed.length })} />
            <Modal.Body>
                <UnorderedList>
                    {failed.map(({ name, extension }, index) => (
                        <ListItem key={`documents:bulk:status:failed:${index}`}>
                            {name}.{extension}
                        </ListItem>
                    ))}
                </UnorderedList>
            </Modal.Body>
            <Modal.Footer>
                <Actions className="stretch">
                    <Plain
                        onClick={dismiss}
                        className="neutral">
                        <FormattedMessage
                            id="action_close"
                            defaultMessage="Close" />
                    </Plain>
                </Actions>
            </Modal.Footer>
        </>
    )
}

export default StatusFailed